import Action from 'src/redux/action'
import { Category, FeatureFragment, PlanFragment } from 'src/graphql'
// relative imports
import {
  clearUpsale,
  highlightPlan,
  upsale,
  upsaleMessage,
} from 'src/redux/actions/plans'
import plansInfo from 'src/marketing/plans/plansInfo'

export interface PlansState {
  plans: PlanFragment[]
  categories: Category[]
  features: FeatureFragment[]
  error: null
  loading: null
  purchasing: boolean
  purchasingError: null
  highlightPlan?: PlanFragment
  upsaleTitle?: string
  upsaleMessage?: string
  upsaleFeatureId?: string
  stripeOrder?: undefined
}

const initialState: PlansState = {
  plans: plansInfo.plans.filter(
    plan => plan.features && plan.features.length > 0,
  ),
  categories: plansInfo.categories,
  features: plansInfo.features,
  error: null,
  loading: null,
  purchasing: false,
  purchasingError: null,
}

const findPlan = (id: string, plans?: PlanFragment[]) => {
  const plan = plans && plans.filter((plan: PlanFragment) => plan.id === id)
  if (plan && plan.length > 0) {
    return plan[0]
  }
  return undefined
}

export default (
  state: PlansState = initialState,
  action: Action,
): PlansState => {
  switch (action.type) {
    case highlightPlan.type:
      return {
        ...state,
        highlightPlan: findPlan(action.planId, state.plans),
      }
    case upsale.type:
      return {
        ...state,
        highlightPlan: findPlan(action.planId, state.plans),
        upsaleFeatureId: action.planId,
      }
    case upsaleMessage.type:
      return {
        ...state,
        upsaleTitle: action.upsaleMessage.title,
        upsaleMessage: action.upsaleMessage.message,
      }
    case clearUpsale.type:
      return {
        ...state,
        highlightPlan: undefined,
        upsaleTitle: undefined,
        upsaleMessage: undefined,
      }
    default:
      return state
  }
}
